import * as THREE from 'three';

function addSegment(p1, p2, vertices) {
  let vec1 = new THREE.Vector3(p1.x, p1.y, p1.z);
  let vec2 = new THREE.Vector3(p2.x, p2.y, p2.z);
  vertices.push(vec1, vec2);
}

export function grid() : THREE.Group {
  const halfSize = new THREE.Vector2(100, 100);
  const step = 5; // make an 5mm grid
  const sectionsX = Math.floor(halfSize.x / step);
  const sectionsY = Math.floor(halfSize.y / step);
  const head = 3;

  let gridlines = [], ticklines = [];
  for (let ind = 1; ind <= sectionsX; ind++) {
    addSegment(
      { x: ind * step, y: -halfSize.y, z: 0 },
      { x: ind * step, y: halfSize.y, z: 0 },
      ind % 5 ? gridlines : ticklines);
    addSegment(
      { x: -ind * step, y: -halfSize.y, z: 0 },
      { x: -ind * step, y: halfSize.y, z: 0 },
      ind % 5 ? gridlines : ticklines);
  }
  
  for (let ind = 1; ind <= sectionsY; ind++) {
    addSegment(
      { x: -halfSize.x, y: ind * step, z: 0 },
      { x: halfSize.x, y: ind * step, z: 0 },
      ind % 5 ? gridlines : ticklines);
    addSegment(
      { x: -halfSize.x, y: -ind * step, z: 0 },
      { x: halfSize.x, y: -ind * step, z: 0 },
      ind % 5 ? gridlines : ticklines);
  } 
  
  const grid = new THREE.Group();
  grid.add(
    new THREE.ArrowHelper(new THREE.Vector3(1, 0, 0), new THREE.Vector3(-halfSize.x, 0, 0), 2 * halfSize.x + step, 0x0000ff, head, head/2),
    new THREE.ArrowHelper(new THREE.Vector3(0, 1, 0), new THREE.Vector3(0, -halfSize.y, 0), 2 * halfSize.y + step, 0x00ff00, head, head/2),
    new THREE.LineSegments(
      new THREE.BufferGeometry().setFromPoints(gridlines), new THREE.LineBasicMaterial({ color: 0xd0d0d0 })
    ),
    new THREE.LineSegments(
      new THREE.BufferGeometry().setFromPoints(ticklines), new THREE.LineBasicMaterial({ color: 0x909090 })
    )
  );
  return grid;
}
